
const moment = require('moment')
//module.exports = {
  function parseParams(data){
    //let parsedUrl = Object.entries(data).map(e => e.join('=')).join('&')
    let parsedUrl = ''
    for(let key in data){
      parsedUrl += '&'+key+'='+encodeURIComponent(data[key])
    }
    for(let key2 in data.filters){
      parsedUrl += '&filter['+key2+']='+encodeURIComponent(data.filters[key2])
    }
    return parsedUrl.substr(1);
  }
  function getAlphabets (){
    let alphabets = []
    // alphabets.push({ text : '', value : ''})
    for(let a = 1;a <= 26;a++){
      let item = {
        text : String.fromCharCode(64 + a),
        value : a
      }
      alphabets.push(item)
    }
    return alphabets
  }
  function getListMenu (){
    return [
      { text: 'Job Type', href: 'jobtype' },
      { text: 'Domain', href: 'domains' },
      { text: 'Vendor Type', href: 'vendortype' },
      { text: 'Transaction Type', href: 'transactiontype' },
    ]  
  }
    function numToMillion(number) {
      var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
      var tier = Math.log10(number) / 3 | 0;
      if(tier == 0) return number;
      var suffix = SI_SYMBOL[tier];
      var scale = Math.pow(10, tier * 3);
      var scaled = number / scale;
      return scaled.toFixed(1) + suffix;
  }
  function getCompanyDetails (){
    let company_data = localStorage.getItem('company_data')
    company_data = JSON.parse(company_data)
    return company_data;  
  }
  function setDateFilterValue (date_filter,start_date,end_date) {
    console.log(date_filter)
    console.log(start_date)
    console.log(end_date)
    localStorage.setItem("report_date_filter", JSON.stringify({
      date_filter: date_filter,
      start_date: start_date,
      end_date: end_date
    }));
  }
  function resetDateFilterValue() {
    localStorage.removeItem('report_date_filter');
  }
  function getDateFilterValue(field_name) {
    let storeData = localStorage.getItem('report_date_filter')
    storeData = JSON.parse(storeData)
    if(storeData) {
      if(field_name == 'display_start_date' || field_name == 'display_end_date') {
        let start_date = ''
        let end_date = moment().format("MM/DD/YYYY")
        if(storeData.date_filter == '1') {
          start_date = moment().format("MM/DD/YYYY")
        } else if(storeData.date_filter == '2') {
          start_date = moment().subtract(7, 'days').calendar();
        } else if(storeData.date_filter == '3') {
          start_date = moment().subtract(30, 'days').calendar();
        } else if(storeData.date_filter == '4') {
          start_date = moment().subtract(60, 'days').calendar();
        } else if(storeData.date_filter == '5') {
          start_date = moment().subtract(90, 'days').calendar();
        } else if(storeData.date_filter == '6') {
          start_date = '01/01/'+moment().format("YYYY");
        } else if(storeData.date_filter == '7') {
          let last_year = moment().format("YYYY")
          last_year = last_year - 1
          start_date = '01/01/'+last_year;
          end_date = '12/31/'+last_year;
        } else {
          if(field_name == 'display_start_date') {
            start_date = storeData.start_date
          } else {
            end_date = storeData.end_date
          }
        }

        if(field_name == 'display_start_date') {
          return start_date
        } else {
          return end_date
        }
      } else {
        return storeData[field_name]
      }
    } else {
      return ''
    }
  }
  function getAmountInWord(s) {
    var th_val = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    var dg_val = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    var tn_val = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    var tw_val = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    s = s.toString();
    //s = s.replace(/[\, ]/g, '');
    if (s != parseFloat(s))
        return '';
    var x_val = s.indexOf('.');
    if (x_val == -1)
        x_val = s.length;
    if (x_val > 15)
        return '';
    var n_val = s.split('');
    var str_val = '';
    var sk_val = 0;
    for (let i = 0; i < x_val; i++) {
        if ((x_val - i) % 3 == 2) {
            if (n_val[i] == '1') {
                str_val += tn_val[Number(n_val[i + 1])] + ' ';
                i++;
                sk_val = 1;
            } else if (n_val[i] != 0) {
                str_val += tw_val[n_val[i] - 2] + ' ';
                sk_val = 1;
            }
        } else if (n_val[i] != 0) {
            str_val += dg_val[n_val[i]] + ' ';
            if ((x_val - i) % 3 == 0)
                str_val += 'Hundred ';
            sk_val = 1;
        }
        if ((x_val - i) % 3 == 1) {
            if (sk_val)
                str_val += th_val[(x_val - i - 1) / 3] + ' ';
            sk_val = 0;
        }
    }
    var amount_arr = s.split('.');
    if (amount_arr[1] && amount_arr[1] > 0) {
      var point_val = amount_arr[1].length;
      var point_n_val = amount_arr[1].split('');
      str_val += 'And ';
      for (let i = 0; i < point_val; i++) {
        if ((point_val - i) % 3 == 2) {
            if (point_n_val[i] == '1') {
                str_val += tn_val[Number(point_n_val[i + 1])] + ' ';
                i++;
                sk_val = 1;
            } else if (point_n_val[i] != 0) {
                str_val += tw_val[point_n_val[i] - 2] + ' ';
                sk_val = 1;
            }
        } else if (point_n_val[i] != 0) {
            str_val += dg_val[point_n_val[i]] + ' ';
            if ((point_val - i) % 3 == 0)
                str_val += 'Hundred ';
            sk_val = 1;
        }
        if ((point_val - i) % 3 == 1) {
            if (sk_val)
                str_val += th_val[(point_val - i - 1) / 3] + ' ';
            sk_val = 0;
        }
      }
      str_val += ' Cents';
    }
    // if (x_val != s.length && amount_arr[1] && amount_arr[1] > 0) {
    //     var y_val = s.length;
    //     str_val += 'And ';
    //     for (let i = x_val + 1; i < y_val; i++)
    //         str_val += dg_val[n_val[i]] + ' ';
    //     str_val += ' Cents';
    // }
    return str_val.replace(/\s+/g, ' ');
  }
  function getUpxDiscount(item, project_created_at, item_price) {
    let discount = 0;
    if(item.on_sale && item.start_date && item.end_date && item.discount && project_created_at) {
      let project_date = moment(project_created_at, "YYYY-MM-DD");
      if(moment(project_date).isBetween(item.start_date, item.end_date, 'days', true)) {
        discount = (item_price * item.discount) / 100;
      }
    }
    return discount.toFixed(2)
  }
  function getMultiplierDiscount(multiplier, amount) {


    let multipler_discount = 0;
    if(multiplier && multiplier < 1) {
      let multiplier_amount = amount * multiplier
      multipler_discount = amount - multiplier_amount;
    }
    return multipler_discount
  }
  function getOverhandAndProfitAmt(overhand_and_profit_per,amount) {
    let overhand_and_profit_amt = 0;
    if(overhand_and_profit_per > 0) {
      overhand_and_profit_amt = (amount * overhand_and_profit_per) / 100
    }
    return overhand_and_profit_amt
  }

  function getTotalOrderAmountwithAllcalculation(overhand_and_profit_per,multiplier,amount){
    let multipler_discount = getMultiplierDiscount(multiplier,amount);
    console.log('multipler_discount',multipler_discount );
    let mamount=amount-multipler_discount;
    let overhand = getOverhandAndProfitAmt(overhand_and_profit_per,mamount)
   
    return (overhand+mamount);
  }
  function logout(router) {
    localStorage.removeItem("token");
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_id');
    localStorage.removeItem('company_data');
    localStorage.removeItem('is_from_project');
    localStorage.removeItem('co_group_id');
    localStorage.removeItem('co_item_id');
    localStorage.removeItem('co_project_id');
    localStorage.removeItem('co_co_id');
    localStorage.removeItem('redirect_to');
    localStorage.removeItem('is_from_dashboard');
    router.push("/login");
  }
  function daysBetweenDates(start_date, end_date){
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);
    const timeDifference = endDate.getTime() - startDate.getTime();
    return   Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  }

//}
 module.exports.parseParams = parseParams
 module.exports.getAlphabets = getAlphabets
 module.exports.getListMenu = getListMenu
 module.exports.numToMillion = numToMillion
 module.exports.getCompanyDetails = getCompanyDetails
 module.exports.setDateFilterValue = setDateFilterValue
 module.exports.resetDateFilterValue = resetDateFilterValue
 module.exports.getDateFilterValue = getDateFilterValue
 module.exports.getAmountInWord = getAmountInWord
 module.exports.getUpxDiscount = getUpxDiscount
 module.exports.getMultiplierDiscount = getMultiplierDiscount
 module.exports.getOverhandAndProfitAmt = getOverhandAndProfitAmt
 module.exports.getTotalOrderAmountwithAllcalculation = getTotalOrderAmountwithAllcalculation
 module.exports.logout = logout
 module.exports.daysBetweenDates = daysBetweenDates



